const comments = [
  {
    name: '追剧小王',
    text: '自从用了芭乐视频，再也不用在各个App之间来回切换了。红桃和樱花的剧集一目了然，更新也及时，强烈推荐给所有追剧党！',
    time: '2天前',
    avatar: 'bg-primary-500',
  },
  {
    name: '电影爱好者',
    text: '芭乐视频的聚合功能太实用了，热门电影大全和最新电视剧都能在一个页面找到。高清不缓冲这点真的没话说，体验满分。',
    time: '5天前',
    avatar: 'bg-accent-500',
  },
  {
    name: '深夜看片人',
    text: '糖豆视频的短剧频道通过芭乐视频才知道的，竖屏看剧确实方便。希望以后能聚合更多像糖豆这样的特色平台，选择更多！',
    time: '1周前',
    avatar: 'bg-secondary-500',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="text-xs font-semibold text-primary-600 uppercase tracking-wider">用户热评</span>
          <h2 className="mt-2 text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            用户热评
          </h2>
          <p className="mt-2 text-sm text-foreground-500">来看看其他观众的真实评价</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-5">
          {comments.map((comment, idx) => (
            <div
              key={idx}
              className="p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className={`w-10 h-10 rounded-full ${comment.avatar} flex items-center justify-center text-white text-sm font-bold`}>
                  {comment.name.charAt(0)}
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{comment.name}</p>
                  <p className="text-xs text-foreground-400">{comment.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {comment.text}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-8 text-center">
          <a
            href="#contact"
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full border border-background-300 text-sm text-foreground-600 hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-chat-1-line"></i>
            我也要说两句
          </a>
        </div>
      </div>
    </section>
  );
}